import { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import "@/App.css";
import { useLenis } from "@/hooks/useLenis";
import { playMusic } from "@/lib/music";
import { Intro } from "@/components/experience/Intro";
import { Hero } from "@/components/experience/Hero";
import { GiftSurprise } from "@/components/experience/GiftSurprise";
import { Manifesto } from "@/components/experience/Manifesto";
import { EditorialMarquee } from "@/components/experience/EditorialMarquee";
import { Balloons } from "@/components/experience/Balloons";
import { FlipReasons } from "@/components/experience/FlipReasons";
import { Gallery } from "@/components/experience/Gallery";
import { Volleyball } from "@/components/experience/Volleyball";
import { OpenWhen } from "@/components/experience/OpenWhen";
import { Letter } from "@/components/experience/Letter";
import { WishCake } from "@/components/experience/WishCake";
import { Footer } from "@/components/experience/Footer";
import { MusicPlayer } from "@/components/experience/MusicPlayer";

function App() {
  const lenisRef = useLenis();
  const [introDone, setIntroDone] = useState(false);

  // Always start from the top, even after a reload
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    window.scrollTo(0, 0);
  }, []);

  // Lock scroll while the intro is up; reset to top when dismissed
  useEffect(() => {
    const l = lenisRef.current;
    if (!introDone) {
      document.body.style.overflow = "hidden";
      l && l.stop && l.stop();
    } else {
      window.scrollTo(0, 0);
      l && l.scrollTo && l.scrollTo(0, { immediate: true });
      l && l.start && l.start();
      document.body.style.overflow = "";
    }
  }, [introDone, lenisRef]);

  const handleIntroDone = () => {
    setIntroDone(true);
    playMusic();
  };

  return (
    <div className="App bg-cream font-body">
      <div className="noise-overlay" aria-hidden="true" />
      <AnimatePresence>
        {!introDone && <Intro onDone={handleIntroDone} />}
      </AnimatePresence>
      <MusicPlayer />
      <main>
        <Hero />
        <GiftSurprise />
        <Manifesto />
        <EditorialMarquee />
        <Balloons />
        <FlipReasons />
        <Gallery />
        <Volleyball />
        <OpenWhen />
        <Letter />
        <WishCake />
        <Footer />
      </main>
    </div>
  );
}

export default App;
